import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-delegate-explanation-mobile',
  templateUrl: './delegate-explanation-mobile.component.html',
  styleUrls: ['./delegate-explanation-mobile.component.scss']
})
export class DelegateExplanationMobileComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
